import type { Rollup } from '../../components/Matrix/types.js';
import type { SyncStatus } from '../../domain/status.js';

/**
 * The rail row's one mark: the worst status across a studio's roll-ups — the studio and every
 * game under it, per environment. The rail sits on the Games page, so its mark is about games;
 * it says where there is work, for choosing what to look at, never the answer itself.
 * Drift outranks missing outranks env-only; unknown only when nothing is known anywhere.
 */
export const railStatus = (rollups: Record<string, Rollup>): SyncStatus => {
    const all = Object.values(rollups);
    const issues = all.filter((r): r is Extract<Rollup, { kind: 'issues' }> => r.kind === 'issues');
    if (issues.some((r) => r.drift > 0)) return 'drift';
    if (issues.some((r) => r.missing > 0)) return 'missing';
    if (issues.some((r) => r.env_only > 0)) return 'env_only';
    if (all.some((r) => r.kind === 'clean')) return 'in_sync';
    return 'unknown';
};
